import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import _ from "lodash";
import Back from "features/metadesk/components/Back";
import UserInfoTitle from "./UserInfoTitle";
import UserInfoTabs from "./UserInfoTabs";
import UserBasicInfo from "./UserBasicInfo";
import { StyledDivider } from "./UserInfo.style";
import { useDispatch } from "react-redux";
import { alertServerError } from "features/helpers/utils";
import axios from "axios";
import { apiUrl } from "features/configure";

const UserInfo = ({
  selectedUserIds,
  entityName,
  isTicketUserInfo,
  getUserList,
}) => {
  const [userBasicInfo, setUserBasicInfo] = useState(null);
  const [userBacisInfoLoading, setUserBacisInfoLoading] = useState(true);
  const dispatch = useDispatch();

  const fetchUserBasicInfo = async () => {
    if (selectedUserIds?.[0]) {
      setUserBacisInfoLoading(true);
      try {
        const result = await axios.get(
          `${apiUrl}/api/user/${entityName}/basicInfo`,
          {
            params: {
              userIds: selectedUserIds,
              view: isTicketUserInfo ? "ticket" : "cdp",
            },
          }
        );
        setUserBasicInfo(result.data);
      } catch (err) {
        dispatch(alertServerError(err));
      } finally {
        setUserBacisInfoLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchUserBasicInfo();
    return () => {
      setUserBasicInfo(null);
    };
  }, [selectedUserIds?.[0]]);

  const renderTicketUserInfo = () => {
    if (!userBasicInfo) {
      return <Box />;
    }
    return (
      <>
        <UserInfoTitle
          entityName={entityName}
          userBasicInfo={userBasicInfo}
          fetchUserBasicInfo={fetchUserBasicInfo}
          isLoading={userBacisInfoLoading}
        />
        <Box sx={{ backgroundColor: "white" }}>
          <UserInfoTabs
            isTicketUserInfo={isTicketUserInfo}
            userBasicInfo={userBasicInfo}
            selectedUserIds={selectedUserIds}
            isLoading={userBacisInfoLoading}
          />
        </Box>
      </>
    );
  };

  const renderUserInfo = () => {
    return (
      <Box display="flex" width="100%" gap={2}>
        <Box
          sx={{
            width: "280px",
            flexShrink: 0,
            backgroundColor: "white",
            minHeight: "calc(100vh - 16px)",
          }}
          className="general-shadow"
        >
          <Box sx={{ marginLeft: "16px" }}>
            <Back />
          </Box>
          <UserInfoTitle
            entityName={entityName}
            userBasicInfo={userBasicInfo}
            fetchUserBasicInfo={fetchUserBasicInfo}
            isLoading={userBacisInfoLoading}
          />
          <StyledDivider />
          <UserBasicInfo
            isTicketUserInfo={isTicketUserInfo}
            userBasicInfo={userBasicInfo}
            isLoading={userBacisInfoLoading}
            getUserList={getUserList}
          />
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
            marginTop: "24px",
          }}
        >
          <UserInfoTabs
            isTicketUserInfo={isTicketUserInfo}
            userBasicInfo={userBasicInfo}
            selectedUserIds={selectedUserIds}
            isLoading={{ userBacisInfoLoading }}
          />
        </Box>
      </Box>
    );
  };

  return isTicketUserInfo ? renderTicketUserInfo() : renderUserInfo();
};

export default UserInfo;
